import Button from "@mui/material/Button";
import { useSelector } from "react-redux";
import classes from "./EllipseButton.module.css";

const EllipseButton = (props) => {
  const isShowLoadingSpinner = useSelector(
    (state) => state.common.isShowLoadingSpinner
  );

  const colorClass = props.disabled
    ? `${classes.button} ${classes.yellowDisabled}`
    : props.isCancelButton
    ? `${classes.button} ${classes.grey}`
    : `${classes.button} ${classes.yellow}`;

  return (
    <div className={classes.ellipseButton}>
      <Button
        disabled={isShowLoadingSpinner || props.disabled}
        type={props.type}
        className={colorClass}
        onClick={props.onClick}
        sx={{minWidth: props?.minWidth !== undefined ? props.minWidth : '180px'}}
      >
        {props.children}
      </Button>
    </div>
  );
};

export default EllipseButton;
